export const isProductSaved = (state, productId) =>
  state.savedItems.savedProducts.findIndex(
    item => item.productId === productId
  ) >= 0;

export const getIdForSavedProduct = (state, productId) =>
  state.savedItems.savedProducts.find(item => item.productId === productId)?.id;
